export const setMasterDB = (state, payload) => {
    state.db = payload
}

export const setRefCompany = (state, payload) => {
    state.refCompany = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/master/mutations.js